'use client'

import React from 'react'
import { motion } from 'framer-motion'

/**
 * Client island: animated fade-in wrapper for feature items.
 * Only this file ships JS to the browser.
 */
export const FadeIn: React.FC<{
  children: React.ReactNode
  delay: number
  className?: string
}> = ({ children, delay, className }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{
      ease: [0.33, 1, 0.68, 1],
      duration: 0.7,
      delay,
    }}
    className={className}
  >
    {children}
  </motion.div>
)

export const SlideUp: React.FC<{
  children: React.ReactNode
  className?: string
}> = ({ children, className }) => (
  <motion.div
    initial={{ opacity: 0, y: 200 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ ease: [0.33, 1, 0.68, 1], duration: 0.8 }}
    className={className}
  >
    {children}
  </motion.div>
)
